import React, { useEffect, useState } from "react";
import {
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Label,
  Input,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Container,
  Button,
} from "reactstrap";
import { showLoading } from "react-global-loading";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Notification from "./Notification";
import Certificates from "./Certificates";
import General from "./General";
import OCRJobs from "./OCRJobs";
import Indexing from "./Indexing";
import { Toolbar } from "../../components/Common/LegacyGridAdapter";

const SettingsRMS = () => {
  const [activeTab, setactiveTab] = useState(1);
  const [active, setActive] = useState("1");

  return (
    <React.Fragment>
      <div className="page-content piers-page">
        <Breadcrumbs
          title="Settings"
          breadcrumbItem="Settings"
          enableAction={false}
        ></Breadcrumbs>
        <Container fluid>
          <CardBody>
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {
                      setactiveTab(1);
                    }}
                  >
                    <span>General</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {
                      setactiveTab(2);
                    }}
                  >
                    <span>Notifications</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 3 })}
                    onClick={() => {
                      setactiveTab(3);
                    }}
                  >
                    <span>Certificates</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 4 })}
                    onClick={() => {
                      setactiveTab(4);
                    }}
                  >
                    <span>Indexing</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 5 })}
                    onClick={() => {
                      setactiveTab(5);
                    }}
                  >
                    <span>OCR Jobs</span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                className="twitter-bs-wizard-tab-content"
                activeTab={activeTab}
              >
                <TabPane tabId={1}>
                  <General />
                </TabPane>
                <TabPane tabId={2}>
                  <Notification />
                </TabPane>
                <TabPane tabId={3}>
                  <Certificates />
                </TabPane>
                <TabPane tabId={4}>
                  <Indexing />
                </TabPane>
                <TabPane tabId={5}>
                  <OCRJobs />
                </TabPane>
              </TabContent>
            </div>
          </CardBody>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SettingsRMS;
